import type { RegisterOptions } from "react-hook-form";
import { Controller, useFormContext } from "react-hook-form";
import {
  CommunityMemberPickerComponent,
  type CommunityMemberPickerComponentProps,
} from "./CommunityMemberPickerComponent";
import type { Value } from "./types";

interface CommunityMemberPickerProps
  extends Omit<
    CommunityMemberPickerComponentProps,
    "onChange" | "value" | "name"
  > {
  name: string;
  rules?: RegisterOptions;
}

export const CommunityMemberPicker = ({
  name,
  rules,
  ...passThroughProps
}: CommunityMemberPickerProps) => {
  const { control } = useFormContext();
  return (
    <Controller<{ [key: string]: Value }>
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, value } }) => (
        <CommunityMemberPickerComponent
          {...passThroughProps}
          onChange={onChange}
          value={value}
          name={name}
        />
      )}
    />
  );
};
